import { Typography } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import { Inline, Stack } from '@superdispatch/ui';
import { WebViewLink } from 'shared/routing/WebViewLinks';
import { ResponsiveTooltip } from 'shared/ui/ResponsiveTooltip';

export function PostingHiddenShipperTooltip() {
  return (
    <Inline noWrap={false} space="xxsmall" verticalAlign="center">
      <Typography color="textSecondary">Hidden by shipper</Typography>
      <ResponsiveTooltip
        interactive={true}
        onClick={(event) => {
          event.stopPropagation();
        }}
        title={
          <Stack>
            <Typography>
              Shipper has hidden contact details from Unverified Carriers. Get
              verified to gain trust and book loads faster.
            </Typography>{' '}
            <WebViewLink
              target="_blank"
              rel="noreferrer"
              color="inherit"
              underline="always"
              onClick={(event) => {
                event.stopPropagation();
              }}
              href="https://support.superdispatch.com/hc/articles/38130807210259-Becoming-A-Verified-Carrier"
            >
              How to Become Verified Carrier?
            </WebViewLink>
          </Stack>
        }
      >
        <Info
          color="action"
          fontSize="small"
          aria-hidden={false}
          aria-label="description tooltip icon"
        />
      </ResponsiveTooltip>
    </Inline>
  );
}
